<template>
  <div class="projects">
    <div class="filters-col">
      <div class="filters">
        <button class="close-filters" v-on:click="toggleFilters">X</button>
        <h2>Áreas</h2>
        <Checkbox v-model="filters.realEstate"> Imobiliárias </Checkbox>
        <Checkbox v-model="filters.medical"> Saúde </Checkbox>
        <Checkbox v-model="filters.restaurant"> Restaurantes </Checkbox>
        <Checkbox v-model="filters.beauty"> Beleza </Checkbox>
        <Checkbox v-model="filters.services"> Serviços </Checkbox>
        <Checkbox v-model="filters.products"> Produtos </Checkbox>
        <h2>Serviços</h2>
        <Checkbox v-model="filters.websites"> Sites </Checkbox>
        <Checkbox v-model="filters.socialMedia"> Redes Sociais </Checkbox>
        <Checkbox v-model="filters.ads"> Campanhas </Checkbox>
        <Checkbox v-model="filters.offline"> Offline </Checkbox>
        <Checkbox v-model="filters.branding"> Branding </Checkbox>
        <Checkbox v-model="filters.websystems"> Sistemas Web </Checkbox>
      </div>
    </div>
    <p v-if="filteredProjects.length === 0">Nenhum projeto encontrado para os filtros selecionados :(</p>
    <div class="projects-col">
      <ProjectCard v-for="project in filteredProjects" :key="project.url" :projectData="project"/>
    </div>
    <button class="filter-toggle" v-on:click="toggleFilters">
      <img src="../assets/magnifying-glass-shadow.svg" alt="Filtrar Resultados" title="Filtrar Resultados">
    </button>
  </div>
</template>

<script>
import ProjectCard from '@/components/ProjectCard.vue'
import Checkbox from 'vue-material-checkbox'

export default {
  name: 'Projects',
  components: {
    ProjectCard,
    Checkbox
  },
  data: function () {
    return {
      categoryName: this.$route.params.categoryName,
      filters: {
        restaurant: false,
        realEstate: false,
        medical: false,
        beauty: false,
        services: false,
        products: false,
        websites: false,
        websystems: false,
        ads: false,
        socialMedia: false,
        offline: false,
        branding: false
      },
      projects: []
    }
  },
  created: function () {
    fetch('https://adminportfolio.emarketingbr.com.br/projects')
      .then((resp) => resp.json())
      .then((data) => {
        this.projects = data
      })
      .catch(err => {
        console.log(err)
      })
    this.filters.restaurant = this.categoryName === 'restaurant'
    this.filters.realEstate = this.categoryName === 'realEstate'
    this.filters.medical = this.categoryName === 'medical'
    this.filters.beauty = this.categoryName === 'beauty'
    this.filters.services = this.categoryName === 'services'
    this.filters.products = this.categoryName === 'products'
    this.filters.websites = this.categoryName === 'websites'
    this.filters.websystems = this.categoryName === 'websystems'
    this.filters.ads = this.categoryName === 'ads'
    this.filters.socialMedia = this.categoryName === 'socialMedia'
    this.filters.offline = this.categoryName === 'offline'
    this.filters.branding = this.categoryName === 'branding'
  },
  computed: {
    filteredProjects: function () {
      let curFilters = this.filters

      let allUnchecked = Object.keys(curFilters).every(function (k) { return !curFilters[k] })

      if (allUnchecked) {
        return this.projects
      } else {
        let hasAreaSet = curFilters.medical || curFilters.restaurant || curFilters.realEstate ||
          curFilters.beauty || curFilters.products || curFilters.services
        let hasServiceSet = curFilters.websites || curFilters.websystems || curFilters.offline ||
          curFilters.ads || curFilters.socialMedia || curFilters.branding

        let filteredProjects = []

        if (hasAreaSet && hasServiceSet) {
          filteredProjects = this.projects.filter(function (p) {
            return curFilters[p.area] && curFilters[p.service]
          })
        } else if (hasAreaSet) {
          filteredProjects = this.projects.filter(function (p) {
            return curFilters[p.area]
          })
        } else if (hasServiceSet) {
          filteredProjects = this.projects.filter(function (p) {
            return curFilters[p.service]
          })
        }
        return filteredProjects
      }
    }
  },
  methods: {
    toggleFilters: function () {
      let filters = document.getElementsByClassName('filters')[0]
      filters.classList.toggle('visible')
      document.body.style.overflow = document.body.style.overflow === 'hidden' ? '' : 'hidden'
    }
  }
}
</script>

<style scoped lang="scss">
  .filter-toggle {
    position: fixed;
    left: 10px;
    bottom: 10px;
    background: none;
    border: none;
    cursor: pointer;
    outline: none;
    padding: 0;

    @media screen and (min-width: 600px) {
      display: none;
    }

    img {
      width: 50px;
      height: auto;
      transition: transform 0.3s;

      &:hover {
        transform: scale(1.2);
      }
    }
  }
  .projects {
    display: grid;
    grid-template-columns: 300px 1fr;
    grid-gap: 10px;

    @media screen and (max-width: 900px) {
      grid-template-columns: 1fr;
    }

    @media screen and (max-width: 600px) {
      grid-gap: 0;
    }

    .filters-col {
      padding: 0 20px 20px;

      @media screen and (max-width: 600px) {
        padding: 0;
      }

      .filters {
        position: sticky;
        top: 20px;
        background-color: #fff;
        border-radius: 10px;
        padding: 20px;
        color: #000;
        box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);

        @media screen and (max-width: 600px) {
          display: none;
        }

        &.visible {
          display: block;
          position: fixed;
          top: 10px;
          left: 10px;
          z-index: 10;
          width: calc(100% - 20px);
          height: calc(100vh - 20px);
          overflow-y: scroll;
        }

        .close-filters {
          border: none;
          width: 30px;
          height: 30px;
          background-color: #573ac7;
          color: #fff;
          border-radius: 50%;
          font-weight: bold;
          position: absolute;
          right: 10px;
          top: 10px;

          @media screen and (min-width: 600px) {
            display: none;
          }
        }

        h2 {
          font-weight: 300;
          margin: 10px;
        }
      }
    }

    .projects-col {
      padding: 0 20px 20px 0;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 30px;

      @media screen and (max-width: 1100px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media screen and (max-width: 900px) {
        padding: 20px;
      }

      @media screen and (max-width: 600px) {
        grid-template-columns: 1fr;
        padding: 0 20px 20px;
      }
    }
  }

  .m-chckbox--container {
    margin: 8px 0;
  }
</style>
